import * as React from 'react'
import axios from 'axios'
import { Container, Grid2, TextField, Button, Typography } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { login, reset } from '../../features/auth/authSlice'

const SignUp = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    React.useEffect(() => {
        let active = true
        axios.get(global.SET_API_URL + 'company/bootstrap-status')
            .then(({ data }) => {
                if (!active) return
                if (data.setupRequired) {
                    localStorage.removeItem('user')
                    dispatch(reset())
                } else {
                    navigate('/Login', { replace: true })
                }
            })
            .catch((error) => window.alert(error.response?.data?.message || 'Setup status check failed'))
        return () => { active = false }
    }, [dispatch, navigate])
    const [file, setFile] = React.useState(null);
    const [cmpData, setCmpData] = React.useState({
        cmpName: '', cmpAddress: '', cmpEmail: '', cmpContact: '', branchName: 'Main Branch', dispName: '', userName: '', userPassword: ''
    })
    const onFileChange = (e) => {
        console.log(e.target.files[0])
        setFile(e.target.files[0]);
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        if (file) formData.append('file', file);
        Object.entries(cmpData).forEach(([key, value]) => formData.append(key, value));
        try {
            await axios.post(global.SET_API_URL + 'company/bootstrap-first-admin', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            const loginResult = await dispatch(login({ userName: cmpData.userName, userPassword: cmpData.userPassword }));
            if (login.fulfilled.match(loginResult)) navigate('/POS');
        } catch (err) {
            window.alert(err.response?.data?.message || err.message || 'First admin setup failed');
        }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCmpData((prevData) => ({
            ...prevData,
            [name]: value
        }));
        console.log(cmpData)
    };

    return (
        <Container component="main" maxWidth="xs">
                <Grid2 container spacing={2} marginBottom={5}>
                    <Grid2 size={12}>
                        <TextField id="cmpName" label="Company Name" variant="outlined" fullWidth name='cmpName' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="cmpAddress" label="Company Address" variant="outlined" fullWidth name='cmpAddress' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="cmpEmail" label="Company E-Mail" variant="outlined" fullWidth name='cmpEmail' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="cmpContact" label="Company Contact" variant="outlined" fullWidth name='cmpContact' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="branchName" label="Main Branch Name" variant="outlined" fullWidth name='branchName' value={cmpData.branchName} onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <input
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="raised-button-file"
                            type="file"
                            onChange={onFileChange}
                        />
                        <label htmlFor="raised-button-file">
                            <Button
                                variant="contained"
                                component="span"
                                fullWidth >
                                Company Image
                            </Button>
                        </label>

                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="dispName" label="User Display Name" variant="outlined" fullWidth name='dispName' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="userName" label="User Name" variant="outlined" fullWidth name='userName' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <TextField id="userPassword" label="User Password" variant="outlined" fullWidth name='userPassword' onChange={handleChange} />
                    </Grid2>
                    <Grid2 size={12}>
                        <Button variant="contained" fullWidth onClick={onSubmit}>CREATE FIRST ADMIN</Button>
                    </Grid2>
                    <Grid2 size={12}><Typography onClick={() => { navigate('/Login') }} sx={{ color: 'grey', cursor: 'pointer', textAlign: 'right' }} >Already Have Account? Please Sign In!...</Typography></Grid2>
                </Grid2>
            </Container>
    )
}

export default SignUp